import { RessourceTypes } from '@/framework/ressource/classes/Ressource';
import { MapRessource, Ressources } from '@/framework/base/helpers/Ressources';

export function RessourceFwkButton(value: FwkButtons): MapRessource {
  return Ressources.newGet(RessourceTypes.BOUTON, FwkButtons[value]);
}

// Enum pour les boutons du Framework
export enum FwkButtons {
  OK = 0,
  IGNORER,
  ENREGISTRER,
  APPLIQUER,
  ANNULER,
  FERMER,
  MODIFIER,
  IMPORTER,
  EXPORTER,
  VALIDER,
  EDITER,
  VALIDER_PAIE,
  APPROVE,
  AJOUTER,
  VERIFIER,
  CONFIRMER,
  LOGIN,
  REGISTER,
  INITIALISER,
  PAYER,
  SUPPRIMER,
  DUPLIQUER,
  RAPPELER,
  VISUALISER,
  COMMENTER,
  SOUSCRIRE,
  RENOUVELLER,
  NEW_ARTICLE,
  NEW_ARTICLE_ITEM,
  MOVE_UP,
  MOVE_DOWN,
  NEW_PROJET,
  NEW_ETABLISSEMENT,
  APPLIQUER_CRENEAUX,
  ENREGISTRER_CRENEAUX,
  CONTINUER,
  GENERER,
  GENERER_VIREMENT,
  PAS_ACCEPTER,
  SIGNER_CONTRAT,
  DOWNLOAD_DOCUMENT,
  DOWMLOAD_A1,
  DISPLAY_A1,
  UPDATE_A1,
  NEW_SALARIE
}

export function RessourceFwkSection(value: FwkSections): MapRessource {
  return Ressources.newGet(RessourceTypes.SECTION, FwkSections[value]);
}

export enum FwkSections {
  ADMIN_EDIT,
  RESSOURCE,
  MODE_CONNEXION,
  REPORT,
  REPORT_VIEWER,
  LOGIN_TITRE,
  FORGOT_PASSWORD,
  CODE_NOT_RECEIVED,
  PAYMENT,
  CATALOGUE,
  FACTURE,
  EXPORT_ATTRIBUTE_LIST,
  EXPORT_ATTRIBUTE_LIST_HEADER,
  LOGIN_ERROR,
  ERROR_TEXT,
  NEW_ETABLISSEMENT,
  NEW_CONTACT,
  CONFIGURE_GESTIONNNAIRE,
  NEW_GESTIONNNAIRE,
  NEW_SALARIE,
  NEW_CONTRAT,
  NEW_APPRENTI,
  NEW_DOCUMENT,
  WIZARD,
  WIZARD_ITEM,
  META_ATTRIBUT,
  META_ATTRIBUT_DIALOG,
  DEFINE_PASSWORD,
  MODIFY_PASSWORD,
  PAGE,
  ACTUALITE
}

export function RessourceFwkControl(value: FwkControls): MapRessource {
  return Ressources.newGet(RessourceTypes.CONTROL, FwkControls[value]);
}

export enum FwkControls {
  SAVE_OR_CANCEL,
  CANCEL_ROUTE,
  DELETE,
  EXPIRED,
  TYPE_EXPORT,
  MONTANT,
  QUANTITE,
  PASSWORD,
  REPEAT_PASSWORD,
  EMAIL,
  IDENTIFIANT,
  CODE_MAIL,
  CODE_SMS,
  REMEMBER_ME,
  MODE_CONNEXION_PASSWORD,
  MODE_CONNEXION_CODE_MAIL,
  MODE_CONNEXION_CODE_SMS,
  REPORT_NOM,
  REPORT_TYPE,
  REPORT_THEME,
  REPORT_MODE,
  REPORT_SUMMARY,
  REPORT_EMETTEUR,
  REPORT_RECEPTEUR,
  REPORT_TITRE,
  REPORT_INFO_1,
  REPORT_INFO_2,
  FILE_NAME,
  EXPORT_FILTERED,
  EMPLOYEUR,
  SALARIE,
  INTERNE,
  TITLE,
  TIMER,
  DESCRIPTION,
  UPLOAD_IMAGE,
  LABEL,
  PROFIL,
  MODULE,
  CI98,
  ACTIVE,
  DOCUMENT_TYPE,
  URL
}


export function RessourceFwkModule(value: FwkModules): MapRessource {
  return Ressources.newGet(RessourceTypes.TUILE, FwkModules[value]);
}

export enum FwkModules {
  ADMINISTRATION,
}

export function RessourceFwkFiche(value: FwkFiches): MapRessource {
  return Ressources.newGet(RessourceTypes.FICHE, FwkFiches[value]);
}

export enum FwkFiches {
  ADMINISTRATION,
}

export const FwkRessources = [
  // Boutons
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.OK], label: 'OK', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.IGNORER], label: 'Ignorer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.ENREGISTRER], label: 'Enregistrer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.APPLIQUER], label: 'Appliquer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.ANNULER], label: 'Annuler', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.FERMER], label: 'Fermer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.MODIFIER], label: 'Modifier', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.IMPORTER], label: 'Importer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.EXPORTER], label: 'Exporter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.VALIDER], label: 'Valider', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.EDITER], label: 'Éditer', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.VALIDER_PAIE],
    label: 'Éditer et régler le bulletin de paie',
    placeholder: ''
  },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.APPROVE], label: 'Accepter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.AJOUTER], label: 'Ajouter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.VERIFIER], label: 'Vérifier', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.CONFIRMER], label: 'Confirmer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.LOGIN], label: 'Me connecter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.REGISTER], label: 'Je crée mon compte', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.INITIALISER], label: 'Importer tout', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.SUPPRIMER], label: 'Supprimer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.DUPLIQUER], label: 'Dupliquer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.RAPPELER], label: 'Me le rappeler', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.VISUALISER], label: 'Visualiser', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.COMMENTER], label: 'Commenter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.SOUSCRIRE], label: 'Souscrire', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.NEW_ARTICLE], label: 'article +', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.NEW_ARTICLE_ITEM], label: 'item +', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.MOVE_UP], label: 'Monter', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.MOVE_DOWN], label: 'Descendre', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.NEW_PROJET], label: 'Ajouter projet', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.NEW_ETABLISSEMENT],
    label: '+ Nouvel établissement',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.NEW_SALARIE],
    label: '+ Nouveau salarié',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.ENREGISTRER_CRENEAUX],
    label: 'Enregistrer',
    placeholder: ''
  },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.CONTINUER], label: 'Continuer', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.APPLIQUER_CRENEAUX],
    label: 'Valider cette date',
    placeholder: ''
  },
  { type: RessourceTypes.BOUTON, name: FwkButtons[FwkButtons.GENERER], label: 'Générer', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.GENERER_VIREMENT],
    label: 'Générer virements',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.PAS_ACCEPTER],
    label: 'Ne pas accepter pour l\'instant',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.SIGNER_CONTRAT],
    label: 'Signer le contrat',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.DOWNLOAD_DOCUMENT],
    label: 'Télécharger le document',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.DOWMLOAD_A1],
    label: 'Télécharger le formulaire A1',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.DISPLAY_A1],
    label: 'Afficher le formulaire A1',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: FwkButtons[FwkButtons.UPDATE_A1],
    label: 'Changer le formulaire A1',
    placeholder: ''
  },

  // Controls
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.SAVE_OR_CANCEL],
    label: 'Voulez-vous enregistrer les modifications ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.CANCEL_ROUTE],
    label: 'Vous allez perdre vos modifications.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.DELETE],
    label: 'La suppression est définitive. Voulez-vous continuer ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.EXPIRED],
    label: 'Le lien que vous avez suivi a expiré',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.TYPE_EXPORT], label: 'Type export', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.MONTANT], label: 'Montant', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.QUANTITE], label: 'Quantite', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.MODE_CONNEXION_CODE_SMS],
    label: 'Recevoir un code de connexion par SMS',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.MODE_CONNEXION_CODE_MAIL],
    label: 'Recevoir un code de connexion par courriel',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.MODE_CONNEXION_PASSWORD],
    label: 'Utiliser un mot de passe',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.PASSWORD],
    label: 'Mot de passe',
    placeholder: 'Mot de passe'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPEAT_PASSWORD],
    label: 'Confirmer le mot de passe',
    placeholder: 'Mot de passe'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.EMAIL],
    label: 'E-mail',
    placeholder: 'Adresse e-mail'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.IDENTIFIANT],
    label: 'Identifiant',
    placeholder: 'Adresse e-mail'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.CODE_MAIL],
    label: 'Code',
    placeholder: 'Code reçu par mail'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.CODE_SMS],
    label: 'Code',
    placeholder: 'Code reçu par SMS'
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REMEMBER_ME],
    label: 'Se souvenir de moi',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_TYPE],
    label: 'Type du rapport',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_NOM],
    label: 'Nom',
    placeholder: 'ex: Rapport de fin d\'année'
  },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.REPORT_MODE], label: 'Mode', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.REPORT_THEME], label: 'Thème', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.REPORT_SUMMARY], label: 'Ressource', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.REPORT_EMETTEUR], label: 'Emetteur', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_RECEPTEUR],
    label: 'Recepteur',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_TITRE],
    label: 'Titre et sous-titre',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_INFO_1],
    label: 'Information avant la liste',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.REPORT_INFO_2],
    label: 'Information après la liste',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.FILE_NAME],
    label: 'Sauvegarder sous le nom',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.EXPORT_FILTERED],
    label: 'Exporter seulement les éléments filtrés',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.EMPLOYEUR], label: 'Employeur', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.SALARIE], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.INTERNE], label: 'Ageta', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.TITLE], label: 'Titre', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.TIMER], label: 'Timer (ms)', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.DESCRIPTION], label: 'Description', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.UPLOAD_IMAGE],
    label: 'Choisir une image',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.LABEL], label: 'Label', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.PROFIL], label: 'Profil', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.MODULE], label: 'Module', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.CI98], label: 'CI98', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.ACTIVE], label: 'Actif', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: FwkControls[FwkControls.DOCUMENT_TYPE],
    label: 'Type de document',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: FwkControls[FwkControls.URL], label: 'Lien', placeholder: '' },
  // Sections
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.ADMIN_EDIT], label: 'Editeur admin', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.RESSOURCE], label: 'RESSOURCE', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.MODE_CONNEXION],
    label: 'Mode de connexion',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.REPORT], label: 'Rapport', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.REPORT_VIEWER],
    label: 'Prévisualisation',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.LOGIN_TITRE],
    label: 'Je me connecte',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.FORGOT_PASSWORD],
    label: 'Mot de passe oublié',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.CODE_NOT_RECEIVED],
    label: 'Code non reçu ?',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.PAYMENT], label: 'Mode de règlement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.CATALOGUE], label: 'Catalogue', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.FACTURE], label: 'Mes factures', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.EXPORT_ATTRIBUTE_LIST],
    label: 'Sélectionnez dans la liste ci-dessous les colonnes à exporter',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.EXPORT_ATTRIBUTE_LIST_HEADER],
    label: 'Colonne',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.LOGIN_ERROR],
    label: '* Identifiant ou mot de passe invalide',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.ERROR_TEXT],
    label: '* Champ(s) manquant(s)',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_ETABLISSEMENT],
    label: 'Nouvel établissement',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_CONTACT],
    label: 'Nouveau contact',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_GESTIONNNAIRE],
    label: 'Nouveau gestionnaire',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.CONFIGURE_GESTIONNNAIRE],
    label: 'Configurer',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_SALARIE],
    label: 'Nouveau salarié',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_CONTRAT],
    label: 'Nouveau contrat',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_APPRENTI],
    label: 'Nouvel apprenti',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.NEW_DOCUMENT],
    label: 'Nouveau document',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.ACTUALITE], label: 'Actualité', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.WIZARD], label: 'Wizard', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.WIZARD_ITEM], label: 'Description', placeholder: '' },
  { type: RessourceTypes.SECTION, name: FwkSections[FwkSections.PAGE], label: 'Page(s)', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.META_ATTRIBUT],
    label: 'Informations complémentaires',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.META_ATTRIBUT_DIALOG],
    label: 'Informations manquantes',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.DEFINE_PASSWORD],
    label: 'Définir mon mot de passe',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: FwkSections[FwkSections.MODIFY_PASSWORD],
    label: 'Modifier mon mot de passe',
    placeholder: ''
  },

  // Modules
  { type: RessourceTypes.MODULE, name: FwkModules[FwkModules.ADMINISTRATION], label: 'ADMIN', placeholder: '' },

  // Modules
  { type: RessourceTypes.TUILE, name: FwkModules[FwkModules.ADMINISTRATION], label: 'Administration', placeholder: '' },

  // Fiches
  { type: RessourceTypes.FICHE, name: FwkModules[FwkFiches.ADMINISTRATION], label: 'Administration', placeholder: '' },
];

export function RessourceAppButton(value: AppButtons): MapRessource {
  return Ressources.newGet(RessourceTypes.BOUTON, AppButtons[value]);
}

// Enum pour les boutons de l'appli
export enum AppButtons {
  CONTRAT_ARTICLE = 0,
  CONTRAT_REMUNERATION,
  CONTRAT_PERIODES,
  REVISION,
  ATTENTE_SIGNATURE_SALARIE,
  ATTENTE_SIGNATURE_REPRESENTANT,
  DOCUMENT,
  AEM,
  VARIABLES,
  FICHE_DE_PAIE,
  INSCRIPTION,
  CALCULER,
  AJOUTER_DATE,
  CONTRAT_OBJET,
  SIGNER,
  SUIVANT,
  PRECEDENT,
  CREER_COMPTE
}

export function RessourceAppSection(value: AppSections): MapRessource {
  return Ressources.newGet(RessourceTypes.SECTION, AppSections[value]);
}

export enum AppSections {
  CONTRAT_VIEWER = 0,
  PAIE_VIEWER,
  PROJET_CONTRAT,
  PROJET_PAIE,
  CONTRAT_ARTICLES,
  CRENEAUX,
  EDIT_CONTRAT_ARTICLE,
  ETABLISSEMENT_IDENTITE,
  ETABLISSEMENT_IMMATRICULATION,
  ETABLISSEMENT_AFFILIATION,
  PROJET,
  REMUNERATION,
  SALARIE,
  VARIABLE_PAIE,
  INSCRIPTION,
  PLAGE_CRENEAUX,
  ABONNEMENT,
  GESTIONNAIRE,
  VERIFICATION,
  COMPTES_CLIENTS,
  RUBRIQUES_VARIABLES,
  DONNEES_PAIE,
  COTISATIONS,
  GRAPH_DIALOG,
  PAYMENT_CB,
  RECCURENT_CB,
  NEW_GESTIONNAIRE,
  NEW_ETABLISSEMENT_HEADER,
  VIREMENT_SALARIE
}

export function RessourceAppControl(value: AppControls): MapRessource {
  return Ressources.newGet(RessourceTypes.CONTROL, AppControls[value]);
}

export enum AppControls {
  SALAIRE_MONTANT,
  SALAIRE_QUANTITE,
  SALAIRE_DATE,
  RUBRIQUE_SELECT,
  PAYMENT_MEANS,
  SELECT_OFFER,
  BILLED_ETAB,
  PAYMENT_MEANS_ABO,
  PAYMENT_MEANS_PAS,
  PAYMENT_MEANS_PAIE,
  CART_GROUPED_BILL,
  LOCALISATION,
  EXONERATION,
  ABATTEMENT,
  REDUCTION,
  ASSOCIATION,
  SOUMIS,
  EFFECTIF,
  NOMBRE,
  DATE,
  CREDITED_ETAB,
  PAYMENT_MEANS_VALIDE
}

export function RessourceAppModule(value: AppModules): MapRessource {
  return Ressources.newGet(RessourceTypes.TUILE, AppModules[value]);
}

export enum AppModules {
  ADMIN,
  SOCIETE,
  CLIENTS,
  PROFIL,
  SALARIE,
  PROJETS,
  CONTRATS,
  PAIES,
  CONTACTS,
  ADMIN_MAILS,
  ADMIN_CONTRAT_ARTICLES,
  ADMIN_RUBRIQUES,
  ADMIN_CALCULETTE_TAUX,
  CATALOGUE
}


export function RessourceAppDialog(value: AppDialogs): MapRessource {
  return Ressources.newGet(RessourceTypes.DIALOG, AppDialogs[value]);
}

export enum AppDialogs {
  SUPPRIME_REMUNERATION,
  SUPPRIME_CRENEAU,
  SUPPRIME_REMUNERATION_REMUNERATION,
}

export function RessourceGenButton(value: GenButtons): MapRessource {
  return Ressources.newGet(RessourceTypes.BOUTON, GenButtons[value]);
}

// Enum pour les boutons de l'appli
export enum GenButtons {

}


export enum GenHeader {
  PAIE_SALARIE = 0,
  PAIE_DATE_FIN,
  EDIT_SALAIRE,
  CONTRAT_INTERVENANT_ID,
  CRENEAU_EDIT,
  EDIT_REMUNERATION
}

export function RessourceAppCustom(value: AppCustoms): MapRessource {
  return Ressources.newGet(RessourceTypes.CUSTOM, AppCustoms[value]);
}

export enum AppCustoms {
  VARIABLE_PAIE_RUBRIQUE = 0,
  VARIABLE_PAIE_DONNEE,
  PERIODE,
  PROJET_CONTRAT_INTERVENANT,
  PROJET_CONTRAT_REMUNERATION,
  PROJET_PAIE_SALARIE,
  PROJET_PAIE_SALAIRE,
  CONTRAT_ARTICLES_TITRE,
  CONTRAT_ARTICLES_COMMENTAIRE,
  CRENEAUX_LISTE,
  CRENEAUX_DATE,
  CRENEAUX_RUBRIQUE,
  CRENEAUX_QUANTITE,
  CRENEAUX_HORAIRES,
  CRENEAUX_DATE_ERROR,
  REMUNERATION_LABEL,
  REMUNERATION_SALARIE,
  REMUNERATION_EMPLOYEUR,
  REMUNERATION_QUANTITE,
  REMUNERATION_BASE,
  REMUNERATION_MONTANT,
  REMUNERATION_SALAIRE_BRUT,
  REMUNERATION_COTISATION_SALARIALE,
  REMUNERATION_COTISATION_PATRONALE,
  REMUNERATION_SALAIRE_NET,
  REMUNERATION_PRELEVEMENT_SOURCE,
  REMUNERATION_PRELEVEMENT_SOURCE_PAYE,
  REMUNERATION_SALAIRE_NET_DEJA_PAYE,
  REMUNERATION_SALAIRE_NET_A_PAYER,
  REMUNERATION_COUT_EMPLOYEUR,
  REMUNERATION_DEJA_PAYEE,
  REMUNERATION_A_PAYER,
  REMUNERATION_FRAIS_GESTION,
  REMUNERATION_FRAIS_SANS_ABO,
  REMUNERATION_BULLETIN,
  NOM,
  PRENOM,
  QUALITE,
  MAIL,
  NUMERO,
  PRESTATAIRE,
  RANG,
  CONTACT,
  COORD,
  FICHE_CONTRAT,
  MODULE_MES_CLIENTS,

  REGISTRE_PERSONNEL_MOIS,
  BILL,
  CONTRAT,
  PAIE,
  REPORT,
  AEM,

  TEST_GRAPH,
  CHOIX_PREVIEW,

  ETABLISSEMENT,

  SUBSCRIPTION_INFO_DUREE,
  SUBSCRIPTION_TEXTE_MENTION_CGU,
  SUSBCRIPTION_SELECTION_MENTION,

  REGISTER_TEXT_INFO_PARAM_CONNEXION,
  REGISTER_ETAPE1_LABEL,
  REGISTER_ETAPE2_LABEL,
  REGISTER_ETAPE3_LABEL,
  REGISTER_ETAPE4_LABEL,
  REGISTER_ETAPE5_LABEL,
  REGISTER_ENVOIE_CODE_VERIF,
  REGISTER_ENVOIE_CODE_VERIF_NUMERO,
  LISTE_SALARIES_VIDE,

  ONBOARDING_ETAPE1_LABEL,
  ONBOARDING_ETAPE2_LABEL,
  ONBOARDING_ETAPE3_LABEL,
  ONBOARDING_VERIF_MAIL,
  ONBOARDING_VERIF_NUMERO,
  ONBOARDING_AUTHENTIFIED,
  ONBOARDING_PROGRESS_ETABLISSEMENT,
  ONBOARDING_PROGRESS_SALARIES,
  ONBOARDING_PROGRESS_AFFILIATIONS,
  ONBOARDING_PROGRESS_CONTRATS,
  ONBOARDING_PROGRESS_PAIES,
  ONBOARDING_PROGRESS_DOCUMENTS_COMPTABLES,
  ONBOARDING_PROJECT_ORGANIZATION_TITLE,
  ONBOARDING_PROJECT_ORGANIZATION_NUMERO_OBJET,
  ONBOARDING_PROJECT_ORGANIZATION_NONE,
  ONBOARDING_PROJECT_ORGANIZATION_MONTH,
  ONBOARDING_PROJECT_ORGANIZATION_YEAR,
  ONBOARDING_INFO_INTRO,
  ONBOARDING_INFO_USAGE_TEXT,
  ONBOARDING_INFO_SUBSCRIPTION_TEXT,
  ONBOARDING_INFO_USAGE_OCCASIONAL_TITLE,
  ONBOARDING_INFO_USAGE_OCCASIONAL_TEXT,
  ONBOARDING_INFO_USAGE_REGULAR_TITLE,
  ONBOARDING_INFO_USAGE_REGULAR_TEXT,
  ONBOARDING_INFO_FREE_PRICE,
  ONBOARDING_INFO_UNLIMITED_PAIE_COUNT,
  ONBOARDING_INFO_CONTEXT,
  ONBOARDING_INFO_QUESTIONS_ONE_TWO,
  ONBOARDING_INFO_QUESTION_THREE,
  ONBOARDING_INFO_INTRO_TITLE,
  ONBOARDING_INFO_READY,
  ONBOARDING_INFO_SERVICE_QUESTION,
  ONBOARDING_INFO_EMPLOYEE_QUESTION,
  ONBOARDING_INFO_PAIE_COUNT_QUESTION,
  ONBOARDING_INFO_SERVICE_TCHAT,
  ONBOARDING_INFO_SERVICE_CALLBACK,
  ONBOARDING_INFO_SERVICE_HOTLINE,
  ONBOARDING_INFO_SERVICE_MANAGER,
  ONBOARDING_INFO_EMPLOYEE_MIXED,
  ONBOARDING_INFO_EMPLOYEE_INTERMITTENTS,
  ONBOARDING_INFO_PAIE_COUNT_LOW,
  ONBOARDING_INFO_PAIE_COUNT_MEDIUM,
  ONBOARDING_INFO_PAIE_COUNT_HIGH,
  ONBOARDING_INFO_START_BUTTON,
  ONBOARDING_INFO_SUGGESTION_BUTTON,
  MIGRATION_IMPOSSIBLE,
  LOGIN_ACCOUNT_DISABLED

}

export const AppRessources = [
  // Boutons
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.CALCULER], label: 'Calculer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.DOCUMENT], label: 'Document', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.REVISION], label: 'Modifications', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.ATTENTE_SIGNATURE_SALARIE],
    label: 'Attente signature salarié',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.ATTENTE_SIGNATURE_REPRESENTANT],
    label: 'Attente signature représentant',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.CONTRAT_ARTICLE],
    label: 'Modifier les articles',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.CONTRAT_REMUNERATION],
    label: 'Modifier la rémunération',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.CONTRAT_OBJET],
    label: 'Modifier l\'objet',
    placeholder: ''
  },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.CONTRAT_PERIODES],
    label: 'Modifier les dates',
    placeholder: ''
  },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.AEM], label: 'AEM', placeholder: '' },
  {
    type: RessourceTypes.BOUTON,
    name: AppButtons[AppButtons.VARIABLES],
    label: 'Frais, accompte et autres variables',
    placeholder: ''
  },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.FICHE_DE_PAIE], label: 'Fiche de paie', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.INSCRIPTION], label: 'S\'INSCRIRE', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.AJOUTER_DATE], label: 'Ajouter date', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.SIGNER], label: 'Signer', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.SUIVANT], label: 'Suivant →', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.PRECEDENT], label: '← Précédent', placeholder: '' },
  { type: RessourceTypes.BOUTON, name: AppButtons[AppButtons.CREER_COMPTE], label: 'Créer mon compte →', placeholder: '' },

  // Controls
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.SALAIRE_MONTANT], label: 'Montant', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.SALAIRE_QUANTITE], label: 'Quantité', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.SALAIRE_DATE],
    label: 'Date',
    placeholder: 'jj/mm/aaaa'
  },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.RUBRIQUE_SELECT], label: 'Variables', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.SELECT_OFFER], label: 'Offre', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.BILLED_ETAB],
    label: 'Etablissement facturé',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.CREDITED_ETAB],
    label: 'Etablissement crédité',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.PAYMENT_MEANS],
    label: 'Moyen de règlement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.PAYMENT_MEANS_ABO],
    label: 'Abonnement mensuel',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.PAYMENT_MEANS_PAS],
    label: 'Prélèvement à la source',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.PAYMENT_MEANS_PAIE],
    label: 'Coût employeur et frais de traitement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.PAYMENT_MEANS_VALIDE],
    label: 'Choisir le mode de règlement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.CART_GROUPED_BILL],
    label: 'Facture groupée bulletins de paie et frais de traitement',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.LOCALISATION], label: 'Localisation', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.EXONERATION], label: 'Exonération', placeholder: '' },
  {
    type: RessourceTypes.CONTROL,
    name: AppControls[AppControls.ABATTEMENT],
    label: 'Abattement des frais',
    placeholder: ''
  },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.REDUCTION], label: 'Réduction', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.ASSOCIATION], label: 'Association', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.SOUMIS], label: 'Soumis a la TVA', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.EFFECTIF], label: 'Effectif', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.NOMBRE], label: 'Nombre', placeholder: '' },
  { type: RessourceTypes.CONTROL, name: AppControls[AppControls.DATE], label: 'Date', placeholder: '' },

  // Sections
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.CONTRAT_VIEWER], label: 'Contrat', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.PAIE_VIEWER], label: 'Paie', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.PROJET_CONTRAT], label: 'Contrats', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.PROJET_PAIE], label: 'Paies', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.CONTRAT_ARTICLES], label: 'Articles', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.CRENEAUX], label: 'Planning', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.EDIT_CONTRAT_ARTICLE],
    label: 'Articles',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.ETABLISSEMENT_IDENTITE],
    label: 'Identité',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.ETABLISSEMENT_IMMATRICULATION],
    label: 'Immatriculation',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.ETABLISSEMENT_AFFILIATION],
    label: 'Affiliation France Travail',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.PROJET],
    label: 'Description du projet',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.REMUNERATION], label: 'Rémunération', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.SALARIE], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.VARIABLE_PAIE], label: 'Variables', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.INSCRIPTION], label: 'Je m\'inscris', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.PLAGE_CRENEAUX],
    label: 'Plage créneaux',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.ABONNEMENT], label: 'Abonnement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.GESTIONNAIRE], label: 'Gestionnaire', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.VERIFICATION], label: 'Vérification', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.COMPTES_CLIENTS],
    label: 'Comptes clients débiteurs',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.RUBRIQUES_VARIABLES],
    label: 'Rubriques et variables de paie',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.DONNEES_PAIE],
    label: 'Données de paie',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.COTISATIONS], label: 'Cotisations', placeholder: '' },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.GRAPH_DIALOG],
    label: 'Données complémentaires',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.PAYMENT_CB],
    label: 'Paiement par carte bancaire',
    placeholder: ''
  },
  {
    type: RessourceTypes.SECTION,
    name: AppSections[AppSections.RECCURENT_CB],
    label: 'Paiement récurrent par carte bancaire',
    placeholder: ''
  },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.NEW_GESTIONNAIRE], label: 'Nouveau gestionnaire', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.NEW_ETABLISSEMENT_HEADER], label: 'Nouvel établissement', placeholder: '' },
  { type: RessourceTypes.SECTION, name: AppSections[AppSections.VIREMENT_SALARIE], label: 'Virements à émettre', placeholder: '' },
  // Dialogs
  {
    type: RessourceTypes.DIALOG,
    name: AppDialogs[AppDialogs.SUPPRIME_REMUNERATION],
    label: 'Modifier l\'intervenant provoquera l\'effacement des taux salarié définis dans la rémunération...\nVoulez-vous continuer ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.DIALOG,
    name: AppDialogs[AppDialogs.SUPPRIME_CRENEAU],
    label: 'Modifier l\'intervenant provoquera l\'effacement des créneaux associés à des rubriques non disponibles pour ce nouveau métier...\nVoulez-vous continuer ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.DIALOG,
    name: AppDialogs[AppDialogs.SUPPRIME_REMUNERATION_REMUNERATION],
    label: 'Modifier l\'intervenant provoquera l\'effacement des créneaux associés à des rubriques non disponibles pour ce nouveau métier et des taux salarié définis dans la rémunération...\nVoulez-vous continuer ?',
    placeholder: ''
  },

  // Modules
  { type: RessourceTypes.MODULE, name: AppModules[AppModules.PROFIL], label: 'Mon profil', placeholder: '' },
  { type: RessourceTypes.MODULE, name: AppModules[AppModules.PROJETS], label: 'Mes projets', placeholder: '' },

  // Modules
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.SOCIETE], label: 'Mes informations', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.CLIENTS], label: 'Clients', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.PROFIL], label: 'Mon profil', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.SALARIE], label: 'Salariés', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.PROJETS], label: 'Mes projets', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.CONTRATS], label: 'Mes contrats', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.PAIES], label: 'Mes payes', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.CONTACTS], label: 'Mes contacts', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.ADMIN], label: 'Administration', placeholder: '' },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.ADMIN_MAILS], label: 'Mails', placeholder: '' },
  {
    type: RessourceTypes.TUILE,
    name: AppModules[AppModules.ADMIN_CONTRAT_ARTICLES],
    label: 'Articles',
    placeholder: ''
  },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.ADMIN_RUBRIQUES], label: 'Rubriques', placeholder: '' },
  {
    type: RessourceTypes.TUILE,
    name: AppModules[AppModules.ADMIN_CALCULETTE_TAUX],
    label: 'Calculettes de taux',
    placeholder: ''
  },
  { type: RessourceTypes.TUILE, name: AppModules[AppModules.CATALOGUE], label: 'Catalogue', placeholder: '' },

  // Des ressource custom
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.VARIABLE_PAIE_RUBRIQUE],
    label: 'Rubrique',
    placeholder: ''
  },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.VARIABLE_PAIE_DONNEE], label: 'Donnée', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PERIODE], label: 'Période', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.PROJET_CONTRAT_INTERVENANT],
    label: 'Intervenant',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.PROJET_CONTRAT_REMUNERATION],
    label: 'Rémunération',
    placeholder: ''
  },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PROJET_PAIE_SALARIE], label: 'Salarié', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PROJET_PAIE_SALAIRE], label: 'Salaire', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CONTRAT_ARTICLES_TITRE], label: 'Titre', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.CONTRAT_ARTICLES_COMMENTAIRE],
    label: 'Commentaire',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.CRENEAUX_LISTE],
    label: 'Liste de créneaux',
    placeholder: ''
  },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CRENEAUX_DATE], label: 'Date', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CRENEAUX_RUBRIQUE], label: 'Rubrique', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CRENEAUX_QUANTITE], label: 'Quantité', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CRENEAUX_HORAIRES], label: 'Horaires', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.CRENEAUX_DATE_ERROR],
    label: '* Sélectionner une ou plusieurs dates',
    placeholder: ''
  },

  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.REMUNERATION_LABEL], label: 'Libellé', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.REMUNERATION_SALARIE], label: 'Salarié', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_EMPLOYEUR],
    label: 'Employeur',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_QUANTITE],
    label: 'Quantité',
    placeholder: ''
  },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.REMUNERATION_BASE], label: 'Base', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.REMUNERATION_MONTANT], label: 'Montant', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_SALAIRE_BRUT],
    label: 'Salaire brut',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_COTISATION_SALARIALE],
    label: 'Cotisations salariales',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_COTISATION_PATRONALE],
    label: 'Cotisations patronales',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_SALAIRE_NET],
    label: 'Salaire net avant impots',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_PRELEVEMENT_SOURCE_PAYE],
    label: 'Prélèvement à la source dèjà prélevé',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_PRELEVEMENT_SOURCE],
    label: 'Prélèvement à la source',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_SALAIRE_NET_DEJA_PAYE],
    label: 'Salaire net déjà payé',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_SALAIRE_NET_A_PAYER],
    label: 'Salaire net à payer',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_COUT_EMPLOYEUR],
    label: 'Coût employeur (hors frais)',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_DEJA_PAYEE],
    label: 'Montant déjà payé',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_A_PAYER],
    label: 'Montant à payer',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_FRAIS_GESTION],
    label: 'Frais de gestion TTC',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_FRAIS_SANS_ABO],
    label: 'Selon abonnement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REMUNERATION_BULLETIN],
    label: 'bulletin',
    placeholder: ''
  },

  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CONTACT], label: 'Contact', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.COORD], label: 'Coordonnées', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.NOM], label: 'Nom', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PRENOM], label: 'Prénom', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.QUALITE], label: 'Qualité', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.MAIL], label: 'Mail', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.NUMERO], label: 'Numéro', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PRESTATAIRE], label: 'Prestataire', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.RANG], label: 'Fraction DSN', placeholder: '' },

  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.FICHE_CONTRAT], label: 'Contrat', placeholder: '' },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.MODULE_MES_CLIENTS],
    label: 'Mes clients',
    placeholder: ''
  },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTRE_PERSONNEL_MOIS],
    label: 'Registres du personnel',
    placeholder: ''
  },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.BILL], label: 'Factures', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.CONTRAT], label: 'Contrats de travail', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.PAIE], label: 'Bulletins de paie', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.REPORT], label: 'Rapports', placeholder: '' },
  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.AEM], label: 'Attestations d\'embauche', placeholder: '' },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.TEST_GRAPH],
    label: 'Test des modèles de conventions',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.CHOIX_PREVIEW],
    label: 'Choix de la convention et du métier',
    placeholder: ''
  },

  { type: RessourceTypes.CUSTOM, name: AppCustoms[AppCustoms.ETABLISSEMENT], label: 'Etablissement', placeholder: '' },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.SUBSCRIPTION_INFO_DUREE],
    label: 'Règlement mensuel pour une durée minimum de 12 mois. Le changement d’offre est possible à tout moment.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.SUBSCRIPTION_TEXTE_MENTION_CGU],
    label: 'En souscrivant, vous acceptez nos <span class="underline">conditions générales d’utilisation </span> relative aux abonnements et attestez avoir lû notre politique de confidentialité.',
    placeholder: ''
  },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.SUSBCRIPTION_SELECTION_MENTION],
    label: '      (*) sans engagement, le bulletin de paie est facturé 8,5% du coût employeur, avec un minimum de 21 euros\n' +
      '      hors-taxes et un maximum de 49 euros hors taxes. (**) pour un engagement de 12 mois, le bulletin de paie est\n' +
      '      facturé 8,5% du coût employeur, avec un minimum de 16 euros hors-taxes et un maximum de 49 euros hors-taxes. Le\n' +
        '      taux moyen constaté en 2025 est de 4,6% du coût employeur. Simulation de facturation pour la rémunération d’un\n' +
      '      comédien réalisant un cachet de 4 heures pour un spectacle vivant : salaire chargé de 200,91 euros,\n' +
      '      correspondant à un cachet brut de 137,87 euros, la facturation du bulletin de paie est de 17,04 euros\n' +
      '      hors-taxes. ',
    placeholder: ''
  },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_TEXT_INFO_PARAM_CONNEXION],
    label: '*Vous pourrez changer ce paramètre dans les préférences de votre profil.',
    placeholder: ''
  },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ETAPE1_LABEL],
    label: 'Bienvenue, comment vous appelez-vous ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ETAPE2_LABEL],
    label: 'Nous serons souvent amenés à communiquer ensemble. Commencez par renseigner vos informations de contact',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ETAPE3_LABEL],
    label: 'Pour quel type d’activité allez-vous gérer vos paies ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ETAPE4_LABEL],
    label: 'Grâce à votre SIRET, notre super <span class="gradient-ia">IA</span> se charge de récupérer toutes les informations légales de votre entreprise.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ETAPE5_LABEL],
    label: 'De quelle manière préférez-vous vous connecter à votre espace privé ?*',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ENVOIE_CODE_VERIF],
    label: 'Avant de commencer à créer vos contrats et fiches de paie, merci de valider <br> votre adresse e-mail grâce au code que nous venons de vous envoyer à ',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.REGISTER_ENVOIE_CODE_VERIF_NUMERO],
    label: 'Etape importante, merci de valider votre n° de téléphone portable en utilisant le code que nous venons de vous envoyer par sms.',
    placeholder: ''
  },

  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_ETAPE1_LABEL],
    label: 'on avait hâte que vous passiez à Ovatio Paie !',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_ETAPE2_LABEL],
    label: 'A l\u2019aide d\u2019un peu de magie, on transporte toutes<br>vos donn\u00e9es \u00e0 leur nouvelle place',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_ETAPE3_LABEL],
    label: 'Choisissez votre abonnement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_VERIF_MAIL],
    label: 'La sécurité a été renforcée, contrôlons d’abord que vous recevez bien nos e-mail à l’aide du code envoyé à',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_ETABLISSEMENT],
    label: 'Votre \u00e9tablissement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_SALARIES],
    label: 'Vos salari\u00e9s',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_AFFILIATIONS],
    label: 'Vos affiliations',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_CONTRATS],
    label: 'Les contrats',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_PAIES],
    label: 'Les paies',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROGRESS_DOCUMENTS_COMPTABLES],
    label: 'Factures & documents comptables',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROJECT_ORGANIZATION_TITLE],
    label: 'Concernant les contrats et les paies depuis début $ANNEE, souhaitez-vous qu\u2019ils soient regroup\u00e9s par :',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROJECT_ORGANIZATION_NUMERO_OBJET],
    label: 'Num\u00e9ro d\u2019objet',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROJECT_ORGANIZATION_NONE],
    label: 'Par num\u00e9ro d\u2019objet',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROJECT_ORGANIZATION_MONTH],
    label: 'Par num\u00e9ro d\u2019objet et par mois',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_PROJECT_ORGANIZATION_YEAR],
    label: 'Par num\u00e9ro d\u2019objet et par ann\u00e9e',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_INTRO],
    label: 'Nous allons vous poser 3 questions qui vont permettre de sugg\u00e9rer l\'offre d\'abonnement qui correspond au mieux \u00e0 vos besoins.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_USAGE_TEXT],
    label: 'Votre activit\u00e9 ressemble plut\u00f4t \u00e0 quel cas ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SUBSCRIPTION_TEXT],
    label: 'Choisissez l\'offre que vous souhaitez utiliser pour d\u00e9marrer.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_USAGE_OCCASIONAL_TITLE],
    label: 'Usage ponctuel',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_USAGE_OCCASIONAL_TEXT],
    label: 'Vous faites quelques paies dans l\'ann\u00e9e et voulez garder un cadre simple.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_USAGE_REGULAR_TITLE],
    label: 'Usage r\u00e9gulier',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_USAGE_REGULAR_TEXT],
    label: 'Vous produisez des paies tout au long de l\'ann\u00e9e et voulez plus de confort.',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_FREE_PRICE],
    label: 'Sans abonnement',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_UNLIMITED_PAIE_COUNT],
    label: 'Nombre illimit\u00e9 de bulletins de paie',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_CONTEXT],
    label: 'Choix d\'abonnement pour {0}',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_QUESTIONS_ONE_TWO],
    label: 'Question 1 & 2',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_QUESTION_THREE],
    label: 'Question 3',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_INTRO_TITLE],
    label: 'Vous y \u00eates ! Place \u00e0 la derni\u00e8re \u00e9tape',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_READY],
    label: 'Vous \u00eates pr\u00eats ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SERVICE_QUESTION],
    label: 'De quel niveau de service avez vous besoin ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_EMPLOYEE_QUESTION],
    label: 'Vous avez l\'habitude de travailler avec :',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_PAIE_COUNT_QUESTION],
    label: 'Combien de bulletins de paie effectuez vous sur une ann\u00e9e ?',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SERVICE_TCHAT],
    label: 'Tchat plateforme int\u00e9gr\u00e9e',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SERVICE_CALLBACK],
    label: 'Rappel si besoin',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SERVICE_HOTLINE],
    label: 'Vous pouvez appeler notre hotline',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SERVICE_MANAGER],
    label: 'Gestionnaire de paie d\u00e9sign\u00e9 qui suit votre dossier',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_EMPLOYEE_MIXED],
    label: 'Des intermittents et des permanents',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_EMPLOYEE_INTERMITTENTS],
    label: 'Uniquement des intermittents',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_PAIE_COUNT_LOW],
    label: '0-24 bulletins de paie / an',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_PAIE_COUNT_MEDIUM],
    label: '25-60 bulletins de paie / an',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_PAIE_COUNT_HIGH],
    label: '+60 bulletins de paie / an',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_START_BUTTON],
    label: 'C\'est parti ! \u2192',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_INFO_SUGGESTION_BUTTON],
    label: 'D\u00e9couvrir la suggestion',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_VERIF_NUMERO],
    label: 'Contrôlons maintenant que vous recevez bien nos SMS à l’aide du code envoyé au',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.ONBOARDING_AUTHENTIFIED],
    label: 'La sécurité a été renforcée, nous avons bien vérifié votre adresse mail $MAIL et votre numéro de téléphone $NUMERO',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.MIGRATION_IMPOSSIBLE],
    label: 'La migration de votre compte ne peut être réalisée pour la raison suivante : <br><strong>$DIALOG</strong><br><br>Le service Conseil et Gestion en est informé et vous contactera dans les meilleurs délais',
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.LOGIN_ACCOUNT_DISABLED],
    label: "Votre accès à l'application a été désactivé suite à la résiliation de votre abonnement.<br><br>Pour toute question, nous vous invitons à nous contacter au 01 30 61 98 81 de 14h à 16h ou par mail à info@cheque-intermittents.com",
    placeholder: ''
  },
  {
    type: RessourceTypes.CUSTOM,
    name: AppCustoms[AppCustoms.LISTE_SALARIES_VIDE],
    label: 'Aucun salarié n\'a été trouvé.',
    placeholder: ''
  }
];
